import { render, staticRenderFns } from "./properties-component-shadow.vue?vue&type=template&id=23afd0c0&scoped=true"
import script from "./properties-component-shadow.vue?vue&type=script&lang=js"
export * from "./properties-component-shadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afd0c0",
  null
  
)

export default component.exports